module.exports = __webpack_public_path__ + "static/img/injuryBody2.01995083.png";